/* Norrviva — homepage patterns: randomise the featured (large) tile.
 *
 * Runs in the browser, so it varies per visit despite Shopify's page-cache
 * (a Liquid "random" would bake one choice into the cached HTML). Once per
 * browser session via sessionStorage: stable while the visitor browses,
 * re-rolled on a return visit. Skipped inside the theme editor so the
 * merchant's configured order stays put while customising.
 *
 * The server always renders block 0 as the featured tile and blocks 1..n in
 * the 2x2 rest grid, so index 0 = the current featured tile and 1..n map to
 * the rest tiles in order. We MOVE the chosen tile's DOM node into the
 * featured slot (and demote the current one), which preserves the swatch
 * hover-swap bindings, and swap the `--featured` class + the image `sizes`
 * so the promoted tile loads a sharp resolution.
 */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  var FEATURED = 'nvv-home-patterns__tile--featured';
  var FEATURED_SIZES = '(min-width: 1100px) 45vw, 90vw';
  var REST_SIZES = '(min-width: 1100px) 22vw, 45vw';

  function run() {
    var sections = document.querySelectorAll(
      '.nvv-home-patterns[data-layout="hero"][data-randomize-featured="true"]'
    );
    for (var i = 0; i < sections.length; i++) randomise(sections[i]);
  }

  function randomise(section) {
    var hero = section.querySelector('.nvv-home-patterns__hero');
    if (!hero) return;
    var current = hero.querySelector('.' + FEATURED);
    var rest = hero.querySelector('.nvv-home-patterns__rest');
    if (!current || !rest) return;

    var restTiles = rest.querySelectorAll('.nvv-home-patterns__tile');
    var tiles = [current];
    for (var j = 0; j < restTiles.length; j++) tiles.push(restTiles[j]);
    if (tiles.length < 2) return;

    var key = 'nvvFeatured:' + (section.getAttribute('data-section-id') || 'patterns');
    var idx = readIndex(key, tiles.length);
    if (idx === 0) return; // block 0 is already the featured tile

    promote(tiles[idx], current, rest);
  }

  function readIndex(key, count) {
    var idx = -1;
    try {
      var stored = window.sessionStorage.getItem(key);
      if (stored !== null) idx = parseInt(stored, 10);
    } catch (e) {}
    if (isNaN(idx) || idx < 0 || idx >= count) {
      idx = Math.floor(Math.random() * count);
      try { window.sessionStorage.setItem(key, String(idx)); } catch (e) {}
    }
    return idx;
  }

  function promote(target, current, rest) {
    var hero = current.parentNode;
    var targetSlot = target.nextSibling; // target's place in the rest grid
    hero.insertBefore(target, current);  // target -> featured slot
    rest.insertBefore(current, targetSlot); // current -> target's old rest cell
    current.classList.remove(FEATURED);
    target.classList.add(FEATURED);
    setSizes(target, FEATURED_SIZES);
    setSizes(current, REST_SIZES);
  }

  function setSizes(tile, sizes) {
    var img = tile.querySelector('img');
    if (img && img.getAttribute('sizes')) img.setAttribute('sizes', sizes);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
